import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";
import { useToast } from "@src/appV2/lib/Notifications";
import { useModalState } from "@src/appV2/redesign/system/ui-components";
// eslint-disable-next-line no-restricted-imports
import { getCognitoSingleton } from "@src/lib/cognito/src/lib/cognitoSingleton";
import { useMutation } from "@tanstack/react-query";

import { AccountDeletionRequestedDialog } from "./AccountDeletionRequestedDialog";
import { useCancelAccountDeletionRequest } from "./api/useCancelAccountDeletionRequest";

export function AccountDeletionRequestedGate() {
  const modalState = useModalState("open");
  const { showErrorToast } = useToast();
  const cancelDeletion = useCancelAccountDeletionRequest();
  const { mutateAsync: signOut, isLoading: isSigningOut } = useMutation({
    mutationFn: async () => {
      await getCognitoSingleton().signOut();
    },
  });

  const handleCancelDeletion = async () => {
    try {
      await cancelDeletion.mutateAsync();
    } catch (error) {
      logError(APP_V2_APP_EVENTS.CANCEL_ACCOUNT_DELETION_REQUEST_FAILURE, { error });
      showErrorToast("Couldn't cancel the deletion request. Please try again.");
    }
  };

  const handleLogout = async () => {
    await signOut();
  };

  return (
    <AccountDeletionRequestedDialog
      modalState={modalState}
      isLoading={cancelDeletion.isLoading || isSigningOut}
      onCancelDeletion={handleCancelDeletion}
      onLogout={handleLogout}
    />
  );
}
